/**
 * ProjectUserRightEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { ProjectUserRoleEntity } from "../ProjectUserRoleEntity";
import { ProjectUserEntity } from "../ProjectUserEntity";
import { ProjectUserRightEntity } from "../ProjectUserRightEntity";
declare global {
    interface EntityTypeMap {
        ProjectUserRight: ProjectUserRightEntity;
    }
}
export abstract class ProjectUserRightGeneratedEntity extends BaseEntity {
    public abstract projectUserRightId: string;
    public abstract templateName: string | null;
    public abstract dependencies: string | null;
    public abstract templateId: string | null;
    public abstract name: string | null;
    public abstract detail: string | null;
    public abstract index: number | null;
    public abstract project: ProjectEntity;
    public abstract workflowRole: ProjectUserRoleEntity | null;
    public abstract readonly users: ReadonlyArray<ProjectUserEntity>;
}
